import SidebarReducer from './sidebar'
import auth from './auth';
import register from './register';
import profile from './profile';
import axios from './axios';
import multiContent from './multicontent';
import ParsialRequest from './parsialRequest';
import app_setting from './appSetting';
import dasboard_field from './hiddenField';
import twofa from './twofa';
import notification from './notifications';
import WaGateway from './WaGateway';
import WaSession from './WaSession';
import WaMessage from './WaMessage';
import WaUi from './WaUi';
import tagihan_selected from './billReducer';


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...auth,
    ...register,
    ...profile,
    ...axios,
    ...app_setting,
    ...dasboard_field,
    ...twofa,
    ...notification,
    ...WaGateway,
    ...WaSession,
    ...WaMessage,
    ...WaUi,
    axiosTemp: multiContent,
    parsial: ParsialRequest,
    set: SidebarReducer,
    tagihan_selected: tagihan_selected,
};
